<template>
    <div id="quote-sheet-reply" class="h-100 w-100 d-flex flex-column">  <!-- top level of QuoteSheetReply -->
    <!-- <b-overlay :show="showSuccessOverlay">
        <template #overlay>
            <save-success></save-success>
        </template> -->

        <success-modal :show.sync="successModalShowing" ref="successModal" icon-font-scale="3"></success-modal>

        <div class="p-3">  <!-- Above Grid Section -->
            <div class="d-flex justify-content-between align-items-end">
                <div class="">
                    <h3>{{ quoteSheetData.title }}</h3>
                    <p v-if="quoteSheetData.instructions" class="text-show-breaks mb-0 max-width-900">{{ quoteSheetData.instructions }}</p>
                </div>

                <div>
                    <div v-if="disableEdit" class="alert alert-danger mb-0 mx-3">
                        No Edits Allowed - Already Submitted
                    </div>
                </div>
                
                <div class="d-flex justify-content-end align-items-end">
                    <div class="mr-4">
                        <b-button v-if="canShowGrid" variant="white-secondary" size="sm" @click="gridApi.sizeColumnsToFit()">
                            <b-icon icon="arrow-bar-left"></b-icon>
                            Fit Columns
                            <b-icon icon="arrow-bar-right"></b-icon>
                        </b-button>
                    </div>
                    <instructions-modal>
                        <ul class="list-flush list-margin-2">
                            <li>Fill in the values in each column in the 'Your Response' section.</li>
                            <li>If the buyer allows 'No Bid' responses, click on the checkbox for 'No Bid' if you choose to not submit a bid on any item.  This can be enabled / disabled by the buyer for each line-item.  If the 'No Bid' column is not shown, then you should submit a bid on each item.</li>
                            <li>To save your response before it is complete, click on 'Save', but you will not be able to submit the full response.</li>
                            <li>Once you are done, click 'Save', then proceed with the next step to submit your entire response.</li>
                        </ul>
                    </instructions-modal>
                </div>
            </div>
        </div>

        <div class="px-3 pb-3 flex-fill w-100 d-flex flex-column">  <!-- Grid Section -->
            <div v-if="mustSelectCurrency" class="d-flex align-items-center justify-content-center">
                <QuoteSheetReplyCurrencyPicker 
                    :replyId="replyId"
                    class="max-width-500"
                    @updated="handleQuotedCurrencyUpdated"
                ></QuoteSheetReplyCurrencyPicker>
            </div>
            <div
                v-if="canShowGrid && !mustSelectCurrency" 
                class="flex-fill shadow" 
                style=""
            >  <!-- Grid Wrapper -->
                <ag-grid-vue
                    ref="theGrid"
                    style="width: 100%; height: 100%;"
                    class="ag-theme-alpine-custom"
                    :gridOptions="gridOptions"
                    :context="gridContext"
                    :columnDefs="columnDefs"
                    :rowData="rowData"
                    :rowClassRules="rowClassRules"
                    :loadingOverlayComponent="loadingOverlayComponent"
                    :loadingOverlayComponentParams="loadingOverlayComponentParams"
                    :autoGroupColumnDef="autoGroupColumnDef"
                    :statusBar="statusBar"
                    @grid-ready="onGridReady"
                    @column-resized="updateRowHeights"
                    @cell-value-changed="onCellValueChanged"
                    @firstDataRendered="onFirstDataRendered"
                    @data-model-changed="onDataModelChanged"
                ></ag-grid-vue>
            </div>
        </div>

        <div class="py-3 pl-3 bg-white" style="padding-right: 100px;">  <!-- Bottom Bar - big padding on right to avoid help widget -->

            <div class="h-100 d-flex justify-content-between align-items-center">
                <!-- <div class="d-flex justify-content-center align-items-center">
                    <div class="mx-3 font-size-80 font-weight-500">
                        Total Lines: 
                        <span class="font-weight-700">{{lineCountTotal}}</span>
                    </div>
                    <div class="mx-3 font-size-80 font-weight-500 d-flex align-items-center">
                        <b-icon icon="check" variant="success" class="p-1 rounded-circle mr-1 bg-success-100" font-scale="2"></b-icon>
                        Completed Lines: 
                        <span class="font-weight-700 ml-1">{{lineCountValid}}</span>
                    </div>
                    <div class="mx-3 font-size-80 font-weight-500 d-flex align-items-center">
                        <b-icon icon="x" variant="danger" class="p-1 rounded-circle mr-1 bg-danger-100" font-scale="2"></b-icon>
                        Incomplete Lines: 
                        <span class="font-weight-700 ml-1">{{lineCountInvalid}}</span>
                    </div>
                </div> -->

                <div class="max-width-600 flex-grow-1 h-100 d-flex justify-content-between align-items-center">
                    <div class="d-flex border mr-3" style="font-size: 11px;">
                        <div class="bg-success-50 py-1 px-2 d-flex justify-content-center align-items-center">
                            Completed
                        </div>
                        <div class="bg-warning-50 py-1 px-2 d-flex flex-column justify-content-center align-items-center">
                            Incomplete
                            <div class="font-italic">(Required)</div>
                        </div>
                    </div>

                    <div class="width-300 h-100 position-relative border rounded-lg bg-gray-100 shadow-inset" style="min-height: 2rem">
                        <div :style="{width: lineCountValidPercent + '%', top: 0, left: 0}" class="bg-success-100 position-absolute h-100"></div>
                        <div class="position-absolute h-100 w-100 d-flex justify-content-center align-items-center">
                            <span class="font-size-70 text-uppercase mr-1">Progress:</span> <span v-if="lineCountTotal" class="font-weight-bold font-size-70">{{ lineCountValid }} completed / {{ lineCountTotal }} total</span>
                        </div>
                    </div>
                </div>

                <!-- <div>
                    <b-button variant="light-secondary" size="sm">
                        <b-icon icon="arrow-bar-left"></b-icon>
                        Adjust Columns
                        <b-icon icon="arrow-bar-right"></b-icon>
                    </b-button>
                </div> -->

                <div class="">
                    <b-alert 
                        :show="hasIncompleteRows"
                        variant="warning"
                        class="mb-0"
                    >
                        <span class="font-weight-bold mr-1">Incomplete Rows:</span>
                        <span>Fill in all yellow shaded cells</span>
                    </b-alert>
                </div>

                <div
                    v-if="hasDifferentQuotedCurrency"
                    class="font-size-70 text-muted"
                >
                    <div class="">Selected Currency for Quote: <span class="text-dark font-weight-bold">{{ quoted_currency }}</span></div>
                    <div class="">Base Currency (from buyer): <span class="text-dark font-weight-bold">{{ quoteSheetData.currency }}</span></div>
                    <div class="text-dark">{{exchangeRateString}}</div>
                </div>

                <!-- <div class="width-300">
                    <b-progress height="2rem" max="100" class="mb-0">
                        <b-progress-bar :value="lineCountValidPercent" variant="success-100" class="text-dark font-size-80">
                            <span><strong>Progress:</strong> {{ lineCountValid }} complete / {{ lineCountTotal }} total</span>
                        </b-progress-bar>
                    </b-progress>
                </div> -->

                <div class="d-flex justify-content-end align-items-center ml-2">
                    <!-- <div>{{ isDirty ? 'D' : 'c'}}</div> -->
                    <!-- <div v-if="!loading && !saving" class="mx-3 text-uppercase font-size-70 font-weight-500">
                        <span v-if="canSubmit" key="readyToSubmit" class="text-success">Ready to Submit</span>
                        <span v-else key="notReadyToSubmit" class="text-muted">Incomplete</span>
                    </div> -->
                    <b-button variant="subtle-secondary" size="lg" class="mx-2" @click="onCloseClick">Close</b-button>
                    <b-button variant="success" size="lg" class="mx-2 px-5" :disabled="disableEdit || saving" @click="saveDraft">Save</b-button>
                    <!-- <span id="qsreply-submit-button-wrapper" class="d-inline-block">  
                        <b-button id="qsheet-reply-submit-button" variant="success" :disabled="!canSubmit" size="lg" class="mx-2" @click="saveSubmit">Save Quotation</b-button>
                    </span> -->
                    <!-- <b-tooltip :disabled="canSubmit" target="qsreply-submit-button-wrapper" triggers="hover">
                        {{ submitBlockedMessage }}
                    </b-tooltip> -->
                </div>
            </div>

            <!-- Placeholder for left side bottom bar -->
            <div v-if="currentUserInfo.user_is_staff">   <!-- Admin-only stuff -->
                <b-link href="#" class="mx-2 small" @click="dumpGrid">Dump Grid</b-link>
                <b-link href="#" class="mx-2 small" @click="dumpApiData">Dump API Data</b-link>
                <b-link href="#" class="mx-2 small" @click="forceGridRefresh">Force Refresh</b-link>
                <b-link href="#" class="mx-2 small" @click="successModalShowing = !successModalShowing">Toggle Success</b-link>
                <b-link href="#" class="mx-2 small" @click="triggerOverlay">Trigger Overlay</b-link>
            </div>

        </div>

    <!-- </b-overlay> -->
    </div>
</template>

<script>
import keyBy from 'lodash/keyBy';
import sortBy from 'lodash/sortBy';
import countBy from 'lodash/countBy';
import cloneDeep from 'lodash/cloneDeep';
import { errorHandling, currentUserInfoMixin } from '../../js/custom-vue-mixins';
import { AgGridVue } from 'ag-grid-vue';
import { hasValueOrZero, FormatDateTimeLocal } from '../../js/filters-helpers';
import { suppliosApi } from '../../js/api-service';
import { QuoteSheet } from './quote-sheet-common-helpers';
import { 
    vendorColsAll,
    ReplyGridBidPriceCellRenderer,
    ReplyGridQuotedPriceRenderer,
} from './quote-sheet-vendor-cols';
import {
    QsItemForReply,
    QsItemVariantForReply,
    QuoteSheetReplyBid,
    BidGridRow,
    StatusBarTotalsComponent,
} from './quotesheet-reply-helpers';
import {
    agNumberFormatter,
    agDateFormatter,
    //agNumberFixedDecimalParser,
} from '../../js/ag-grid-helpers';
import {
    SimplePlaceholderRenderer,
    SavingOverlayComponent,
    GenericBooleanRenderer,
    ValidationStatusRenderer,
    validSnippet,
    invalidSnippet,
    DisabledVendorInputRenderer,
    NoBidInputRenderer,
    SimpleDisabledInputRenderer,
    PriceCellRenderer,
    BootstrapVueDatePickerEditor,
    //VueDatePickerEditor,
    VueDateButtonRenderer,
    LeadTimeEditor,
    GenericCheckboxCellRenderer,
    VendorResponseHeaderRenderer,
    DynamicPaddingRenderer,
} from './quote-sheet-components';
import QuoteSheetReplyCurrencyPicker from './QuoteSheetReplyCurrencyPicker.vue';


const variantGetter = function(params) {
    // value getter for ag-grid cells to pull data from nested 'variant' object
    let fieldKey = params.colDef.field;
    return params.data ? params.data.variant[fieldKey] : '';
}


export default {
    name: 'QuoteSheetReply',
    components: {
        AgGridVue,
        QuoteSheetReplyCurrencyPicker,
    },
    mixins: [
        errorHandling,
        currentUserInfoMixin,
    ],
    props: {
        replyId: {
            type: String,
            required: true,
        }
    },
    data: function() {
        return {
            errorMsg: 'Error',
            error: false,
            canShowGrid: false,
            loading: false,  // initial load of data
            saving: false,  // loading indicator when saving data
            gridOptions: null,  // set in beforeMount
            gridContext: null,  // (context) set in beforeMount, separate from gridOptions, then update if/when needed
            columnDefs: null,  // build initially in beforeMount, then re-set it after getting API data
            rowData: [],
            hasMultipleVariants: false,  // set to true if there are ANY line items that have multiple variants -- check/set as you're building rows from API data
            rowClassRules: null,  // set in beforeMount
            loadingOverlayComponent: 'savingOverlayComponent',
            loadingOverlayComponentParams: {loadingMessage: 'Loading...'},  // overwrite entire objectin a method... better than doing a computed property because it will happen right away
            quoteSheetData: new QuoteSheet({}),  // data from API, will not change here in the reply
            quoteSheetReplyData: {  // a simple object to hold the few 'metadata' things on THIS reply
                //id: '',  // should be the ID of THIS reply -- so maybe don't put it here... get from prop for DRY
                //quotesheet: '',  // should be the ID of the QuoteSheet -- don't put in here, but add to object when you send to backend
                comment: '',  // comment field... you have it on backend
                // NOTE - quoted_currency is separate... not allowing it to be set here, at least for now (May 29 2023)
            },  
            vendorColsAll: vendorColsAll,  // from import of list from helper js file
            autoGroupColumnDef: null,  // set in beforeMount
            // line counts - set using this.updateCounts(rowData)
            lineCountTotal: null,
            lineCountValid: null,
            lineCountInvalid: null,
            validationSnippets: {  // these are imported from your quote-sheet-components file, as they are used there also (DRY) - just string HTML snippets
                valid: validSnippet,
                invalid: invalidSnippet,
            },
            isDirty: false,  // dirty flag, to show we have unsaved changes - set to true anytime you have changes to data
            successModalShowing: false,
            showSuccessOverlay: false,
            disableEdit: false, // if is_submitted already, we set this true, then check this before allowing cells editable
            statusBar: null,  // set it in beforeMount with other ag-grid stuff
            grandTotal: null,  // if you're showing the grand total (sum of subtotal) put it here - in the QuoteSheet currency - NOT quoted_currency
            quotedGrandTotal: null,  // grandTotal IN quoted_currency
            // MULTI-CURRENCY STUFF - also in computed
            quoted_currency: null,  // this is top-level in reply data - might be '' if supplier needs to select it
            exchangeRateData: {},  // serialized ExchangeRateData if we have quoted_currency set - has base_code, target_code, base, target, rate, and more -- target = base * rate -- base = target / rate
            // hasDifferentQuotedCurrency - computed - true if quoted_currency is different from quote sheet currency (that is the base currency)
            // currency options -- they are on quotesheet
        }
    },
    computed: {
        mustSelectCurrency() {
            // return true if we have reply data, but specifically know that the quoted_currency is not set
            const hasData = !!this.quoteSheetData.id;  // just a way of knowing if we have data from API
            return hasData && !this.quoted_currency;  // 
        },
        hasDifferentQuotedCurrency() {
            // only returns true if we already have currency selected 
            return this.quoted_currency && (this.quoted_currency !== this.quoteSheetData.currency);
        },
        exchangeRate() {
            return this.exchangeRateData?.rate ?? null; 
            // then use this in a standard method for converting quoted_price to price (for read-only)
            // target = base * rate 
        },
        exchangeRateString() {
            if (!hasValueOrZero(this.exchangeRate)) {
                return '';
            }
            const asOfDateTimeString = this.exchangeRateData.timestamp ? FormatDateTimeLocal(this.exchangeRateData.timestamp) : '';
            return `1 ${this.quoted_currency} = ${this.exchangeRate} ${this.quoteSheetData.currency} (${asOfDateTimeString})`;
        },
        canSubmit: function() {
            let linesValid = this.lineCountInvalid === 0;  
            let noApiCall = !this.loading && !this.saving;
            return linesValid && noApiCall && !this.disableEdit;
        },
        submitBlockedMessage: function() {
            let msg = 'Must complete all required lines before you can submit.';
            if (this.disableEdit) {
                msg = 'No edits allowed.  Already submitted.';
            }
            return msg;
        },
        lineCountValidPercent: function() {
            return Math.round((this.lineCountValid / this.lineCountTotal) * 100);
        },
        hasIncompleteRows() {
            return this.lineCountInvalid > 0;
        },
    },
    beforeMount: function() {
        // ag-grid setup
        this.gridOptions = {
            // moved all context out of here, using direct binding to grid via this.gridContext
            components: {
                simpleDisabledInputRenderer: SimpleDisabledInputRenderer,  // USE THIS -- not a vue component, but simple and works great
                noBidInputRenderer: NoBidInputRenderer,  // use this for cells when the vendor selects 'No Bid' in the row
                priceCellRenderer: PriceCellRenderer,  // for rendering placeholder for price
                replyGridBidPriceCellRenderer: ReplyGridBidPriceCellRenderer,  // specifically for rendering inputs for vendor bid price
                replyGridQuotedPriceRenderer: ReplyGridQuotedPriceRenderer,
                simplePlaceholderRenderer: SimplePlaceholderRenderer,  // must have cellRendererParams: { placeholder: 'Placeholder Text' }
            },
            frameworkComponents: {
                // use componentName: ComponentName format (note small letter, big letter)
                // then use: colDef: {cellRenderer: 'componentName'}  // small letter, string name
                savingOverlayComponent: SavingOverlayComponent,
                bootstrapVueDatePickerEditor: BootstrapVueDatePickerEditor,
                //vueDatePickerEditor: VueDatePickerEditor,
                vueDateButtonRenderer: VueDateButtonRenderer,
                leadTimeEditor: LeadTimeEditor,
                genericCheckboxCellRenderer: GenericCheckboxCellRenderer,
                disabledVendorInputRenderer: DisabledVendorInputRenderer,
                genericBooleanRenderer: GenericBooleanRenderer,
                vendorResponseHeaderRenderer: VendorResponseHeaderRenderer,
                dynamicPaddingRenderer: DynamicPaddingRenderer,
                validationStatusRenderer: ValidationStatusRenderer,  // very simple way of showing OK/Invalid 
                statusBarTotalsComponent: StatusBarTotalsComponent,
            },
            tooltipShowDelay: 500,  // in ms
            enterMovesDown: true,
            enterMovesDownAfterEdit: true,  // this seems annoying when using select boxes -- hit enter to select, then moves down -- turn off
            //rowSelection: "multiple",
            enableRangeSelection: true,
            enableFillHandle: true,
            fillHandleDirection: 'y',
            suppressClearOnFillReduction: true,
            //stopEditingWhenGridLosesFocus: true,
            stopEditingWhenCellsLoseFocus: true,  // this replaces stopEditingWhenGridLosesFocus - which was deprecated
            undoRedoCellEditing: true,  // seems to not work on tree data since it does auto-grouping
            rowHeight: 50, // TODO - make this dynamic, based on how many items we have
            headerHeight: 50,
            groupHeaderHeight: 60,
            applyColumnDefOrder: true,  // this honors the column order in colDefs, even when updating them after initial load
            groupSuppressAutoColumn: true,  // not using the group auto col... 
            groupHideOpenParents: true,   // groupRemoveSingleChildren and groupHideOpenParents cannot be used together!
            groupDefaultExpanded: -1,  // number of levels to expand by default... -1 means all, always
            getRowNodeId: function(data) {
                return data ? data.rowId : '';  // should return strings
            },  // use this to have grid use your own defined node IDs... or let it use its own.  should return strings.
            // makes it easier to get/call row nodes later, such as:  var rowNode = api.getRowNode('55');
            // PASTE OPERATIONS
            /* processCellFromClipboard: function(params) {
                // this is called for EACH CELL when being pasted - https://www.ag-grid.com/archive/25.3.0/vue-grid/clipboard/
                // pasted from another cell, OR pasted from external source (user will need to confirm to browser that paste is OK)
                // there are other methods for processing for COPY (other direction) and one that allows processing the entire 2D copy/pasted grid... this is only for single cells
                // params: { value, node, column, api, columnApi, context, type } - type will be a string from these options: clipboard, dragCopy (Ctrl+D), export
                console.log('HELLO FROM processCellFromClipboard - params:', params);
                console.log('Do we have colDef.genericValueParser?', !!params.column.colDef?.genericValueParser);
                // if you didn't specify a genericValueParser in vendor col, your colDef builder set it to null.... so property is still there, but null, not a function
                const pasteValueParser = params.column.colDef?.genericValueParser;
                if (pasteValueParser) {
                    return pasteValueParser(params.value);
                } else {
                    return params.value;  // if no function, just return the value
                }
            }, */
            // COL DEF RELATED
            defaultColDef: {
                resizable: true,
                suppressMovable: true,
                suppressMenu: true,  // hides the menu for each col... set false if you want filters, or use inline/floating? filters
                wrapText: true, 
                autoHeight: true,  // not allowed if doing row spanning!
                singleClickEdit: false,
                enableCellChangeFlash: false,  // annoying
            },
            columnTypes: {
                'quantityCol': {
                    editable: false,
                    valueGetter: variantGetter,
                    cellClassRules: {
                        //'bg-warning-50': this.isVariantRow,
                    },
                },
                'noEditCol': {
                    editable: false,
                },
                'firstChildVisible': {  // use in cols where you only want first child to be visible... use with groupHideOpenParent row grouping
                    cellClassRules: {
                        'd-none': (params) => {return params.node.childIndex !== 0},
                    },
                },
            },
        };
        this.gridContext = {  // this is passed to grid :context="gridContext"
            componentParent: this,  // then child 'framework components' inside here can access this 'parent' component via this.params.context.componentParent
            currency: this.quoteSheetData.currency,  // this sets initial value, but its not reactive... have to update explicitly on changes (when fetched from API)
            quoted_currency: this.quoted_currency,  // this sets initial value, but its not reactive... have to update explicitly on changes (when fetched from API)
            countryCodes: [],  // array of code strings only, sets initial value, but not reactive... have to update explicitly on changes (when fetched from API)
            countryNames: [],  // array of just the names, useful for filtering in the dropdown
            countryNamesByCode: {},  // {code: name, code: name, ...} sets initial value, but not reactive... have to update explicitly on changes (when fetched from API)
            countryCodesByName: {},  // {name: code, name: code, ...} sets initial value, but not reactive... have to update explicitly on changes (when fetched from API)
        },
        this.rowClassRules = {
            'item-firstrow': (params) => {
                return params.node.firstChild;  // when using row grouping with hidden open parents, this will be first row if there are multiple variants, or just one variant
            },
            'item-midrow': (params) => {
                return !params.node.firstChild && !params.node.lastChild;
            },
            'item-lastrow': (params) => {
                return params.node.lastChild;  
            },
            'group-multiple-variants': (params) => {
                return params.node.parent && (params.node.parent.allChildrenCount > 1);
            },
            'group-single-variant': (params) => {
                return params.node.parent && (params.node.parent.allChildrenCount === 1);
            } ,
        };
        /* this.statusBar = {
            statusPanels: [
                { 
                    statusPanel: 'statusBarTotalsComponent',
                    statusPanelParams: {
                        currency: 'USD',
                        decimal_places: 4,
                    }
                }
            ],
        }; */
        this.columnDefs = this.buildColDefs();  // this will return colDefs as defined, but some vue data may not be ready yet... so might have to call/update later?
    },
    mounted: function() {
        // ag-grid stuff
        // this.gridApi = this.gridOptions.api;
        // this.gridColumnApi = this.gridOptions.columnApi;     
        this.getData();  // main API data fetch
    },
    methods: {
        handleQuotedCurrencyUpdated(currencyObj) {
            // called from event handler on currency selector component after supplier picks one
            // basically, we want to reload everything
            console.log('currency was selected, will now restart with getData', currencyObj);
            this.getData();  // this will also update the 'currency' in gridContext
        },
        triggerOverlay: function() {
            this.showSuccessOverlay = true;
            setTimeout(() => {
                this.showSuccessOverlay = false;
            }, 4000);
        },
        // use apiErrorHandler from mixin
        // GRID CALLBACKS
        onGridReady: function(gridReadyParams) {
            // do stuff here that you need grid to be ready for, just another hook point
            // we moved even more stuff here (from mounted hook), since we're not actually showing the grid right away... 
            console.log('gridReady params');
            console.log(gridReadyParams);
            this.gridApi = this.gridOptions.api;
            this.gridColumnApi = this.gridOptions.columnApi; 
            this.gridApi.expandAll();
            this.gridApi.sizeColumnsToFit();
        },
        updateRowHeights: function(params) {  // triggered by @column-resized event
            //console.log('called updateRowHeights - params');
            //console.log(params);
            if (params && (params.finished !== false)) {  // check if finished, if params has that... it may not
                console.log('updating row heights');
                params.api.resetRowHeights();
            } else if (!params) {
                // but maybe we called from a place without passing in params... 
                console.log('updating row heights');
                this.gridApi.resetRowHeights();
            }
        },
        updateNodeRowHeight: function(rowNodeArray, height) {
            // pass in a SINGLE rowNode OR an ARRAY of rowNodes, optionally pass in a specific height to use
            // if no height, grid will calculate it
            // first, set new heights for each node --> then call onRowHeightChanged() to actually reposition the DOM
            let nodesToUpdate = Array.isArray(rowNodeArray) ? rowNodeArray : [rowNodeArray];  // make an array if only passed in one
            nodesToUpdate.forEach(node => {
                node.setRowHeight(height);  // height may be null, undefined, which is OK -- grid will calculate
            });
            this.gridApi.onRowHeightChanged();  // this actually updates the DOM
        },
        onCellValueChanged: function(eventParams) {
            // do stuff when a cell is edited, like validate the row, etc.
            // for better performance using fill-handle (and other things) look at event to see if its 'done' -- should check event type too
            // or have other function triggered by RangeSelectionChangedEvent start/finish that 'suspends' these updates while dragging, then batches them at end
            /* RangeSelectionChangedEvent {
        │       started: boolean, // true for first event in a sequence of dragging events
        │       finished: boolean // true for last event in sequence of dragging events */
            console.log('cell value changed - params');
            console.log(eventParams);
            this.isDirty = true;  // our main flag to show unsaved changes
            this.onDataChange();
            //this.validateNode(eventParams.node);
            // only update rowHeight if editing a column that might need it -- otherwise it interferes with tabbing from col to col when editing
            let colIdsToUpdateRowHeight = ['comment'];  // only cols that are editable, and have wrapped text -- you could inspect colDef too... but then have to make sure you don't have wrapText when you don't mean it...
            if (colIdsToUpdateRowHeight.includes(eventParams.column.colId)) {
                this.updateNodeRowHeight(eventParams.node, null);  // it can take a single rowNode, or array of rowNodes
            }
        },
        setGrandTotal() {  // SETS BOTH grandTotal and quotedGrandTotal
            // calculate it then set on this.grandTotal / this.quotedGrandTotal
            // only if enable_subtotal is set -- you handle that in valueGetter for subtotal, so just use getValue('subtotal', node) and it returns null if no subtotal enabled for that row
            let total = 0;
            let quotedTotal = 0;
            this.gridApi.forEachNode((node) => {
                // price / subtotal
                // TODO - must actually get the 'calculatedSubtotal' from BidGridRow -- that is live updated & converted price, converted from quoted_price
                // const nodeData = node.data;  // a BidGridRow - but only for rows with data (not all are shown)
                // you have a custom valueGetter for both 'subtotal' and 'quoted_subtotal' columns that use calculatedSubtotal and calculatedQuotedSubtotal getters on BidGridRow
                const rawLineSubtotal = this.gridApi.getValue('subtotal', node);  // might be NaN or null
                const lineSubtotal = hasValueOrZero(rawLineSubtotal) ? rawLineSubtotal : 0;
                total = total + lineSubtotal;
                // quoted_price / quoted_subtotal
                const rawLineQuotedSubtotal = this.gridApi.getValue('quoted_subtotal', node);  // might be NaN or null
                const lineQuotedSubtotal = hasValueOrZero(rawLineQuotedSubtotal) ? rawLineQuotedSubtotal : 0;
                quotedTotal = quotedTotal + lineQuotedSubtotal;
            });
            this.grandTotal = total;
            this.quotedGrandTotal = quotedTotal;
            console.log('Quoted Grand Total:', quotedTotal, 'Grand Total:', total);
        },
        setStatusBar() {
            // call this after updating the colDefs
            // if we have subtotals column enabled, then we'll show the grand totals in statusBar
            if (this.quoteSheetData?.vendorCols?.enable_subtotal) {
                console.log('TURNING ON STATUS BAR');
                this.statusBar = {
                    statusPanels: [
                        { 
                            statusPanel: 'statusBarTotalsComponent',
                            statusPanelParams: {
                                currency: this.quoteSheetData.currency,
                                quoted_currency: this.quoted_currency,
                            }
                        }
                    ],
                };
            }
            // call this to calculate the total, which is displayed in statusBar, and recalculated on any change
            // HOWEVER, we likely won't have rowData yet... so need to do it when you have rowData
            //this.setGrandTotal();  
        },
        onFirstDataRendered(eventParams) {
            // when the first data is rendered by the grid, after gridReady
            // call things that need to happen when row data / cells are updated
            console.log(eventParams);
            this.onDataChange();  
        },
        onDataChange() {
            // collect things that need to be called on any data change here
            // this is not specifically for a single event from the grid
            this.updateCounts();
            this.setGrandTotal();
        },
        onDataModelChanged: function() { // (rowData) rowData is passed in (data, not nodes)... use it
            // I THINK THIS IS A DEPRECATED EVENT
            // triggered from data-model-changed event from the grid -- if this fires often for things like fill-handle drags, check event to see if its 'done'
            //this.updateRowHeights();
            console.log('Data model changed!');
            //this.currentGridData = rowData;  // not used
            //this.updateCounts();  // (rowData);
            // calculate grand total!
            //this.setGrandTotal();
            //this.updateLinkedProductIds(rowData);
            //console.log(rowData);
            // do other / more stuff too...
            // THIS WORKS TO UPDATE ROW GROUPS (refreshClientSideRowModel('group') -- but call it in a more targeted way!!!)
            // this.gridApi.refreshClientSideRowModel('group');  // refresh all the data starting from group step (the first step)
        },
        forceGridRefresh: function(showFlash) { // helper method to force entire grid to refreshCells -- not redrawRows
            // by default we will suppressFlash: true -- but if you pass showFlash arg as true, we won't suppress it
            let refreshParams = {
                //rowNodes: [array of rowNodes],
                //columns: ['current_price', 'target_price'],
                force: true,
                suppressFlash: showFlash ? false : true,
            };
            this.gridApi.refreshCells(refreshParams);
        },
        updateCounts: function() {
            //console.log('rowData from updateCounts');
            //console.log(rowData);
            //this.lineCountTotal = rowData.filter(data => !!data).length;
            // Aug 6 2022 - changed to not pass in rowData - get it here
            const rowData = this.getRealRowData();
            let { valid, invalid } = countBy(rowData, 'isValidStatus');  // will return an object with keys of 'valid'/'invalid' and associated counts
            this.lineCountValid = valid || 0;
            this.lineCountInvalid = invalid || 0;
            this.lineCountTotal = this.lineCountValid + this.lineCountInvalid;  // is this safe?  seems so
        },
        dumpGrid: function() {
            // just dump grid data to console for testing
            let gData = [];
            let allNodes = [];
            this.gridApi.forEachNode((node, index) => {
                allNodes.push(node);
                gData.push({
                    grid_index: index,
                    ...node.data,
                });
            });
            console.log('NODES:');
            console.log(allNodes);
            console.log('ROW DATA:');
            console.log(gData);
            console.log('getFirstDisplayedRow');
            console.log(this.gridApi.getFirstDisplayedRow());
            console.log('getLastDisplayedRow');
            console.log(this.gridApi.getLastDisplayedRow());
        },
        updateGridContext: function() {
            // call this when things change that are inside grid context (this.gridContext)
            // such as currency, other things when you get data from API
            // make sure local data option is updated - used nextTick
            //this.gridContext.currency = this.quoteSheetData.currency;
            this.$nextTick(() => {
                // OLD this.gridContext.currency = this.quoteSheetData.currency;
                const QuoteSheetCurrencyCode = this.quoteSheetData.currency;
                this.$set(this.gridContext, 'currency', QuoteSheetCurrencyCode);
                const QuotedCurrencyCode = this.quoted_currency;  // we SHOULD have this when grid is showing, or else currency picker should be showing
                this.$set(this.gridContext, 'quoted_currency', QuotedCurrencyCode);
                this.$set(this.gridContext, 'countryCodes', this.quoteSheetData.countryCodes);
                this.$set(this.gridContext, 'countryNames', this.quoteSheetData.countryNames);
                this.$set(this.gridContext, 'countryNamesByCode', this.quoteSheetData.countryNamesByCode);
                this.$set(this.gridContext, 'countryCodesByName', this.quoteSheetData.countryCodesByName);
            });
        },
        updateColDefs: function() {
            // this builds AND SETS new colDefs -- call this after doing things that affect what is shown
            let newColDefs = this.buildColDefs();
            //this.gridApi.setColumnDefs(newColDefs); // this is how ag-grid example does it, even with :columnDefs="columnDefs"
            this.columnDefs = newColDefs;
            this.setStatusBar();  // this needs to know which cols are present
            //this.forceGridRefresh();
            //this.gridApi.sizeColumnsToFit(); // this will trigger event, which triggers update row heights also
        },
        buildResponseColDefs: function() {
            // build colDefs for vendor response cols, then return the array, don't set columnDefs on data here
            // you only need to add the cols that are enabled on the QuoteSheet -- forget about the others
            let responseColDefs = [];  // build this up...
            // define a bunch of functions that you'll set for each column
            /* const vcolGetter = (params) => {
                let fieldKey = params.colDef.field;  // plainKey - something like 'price' -- WITHOUT 'enable_'
                return params.data ? params.data.bid[fieldKey] : '';
            };
            const vcolSetter = (params) => {
                //console.log('hello from vcolSetter - params');
                //console.log(params);
                let fieldKey = params.colDef.field;  // field is based on plainKey - something like 'price' WITHOUT 'enable_
                // if ( some condition? )return false;  // if this row doesn't meet some condition, return false to discard the edit
                params.data.bid[fieldKey] = params.newValue;  // params.data is the object/data for this bid
                return true;  // return true to let ag-grid know we updated it, so it refreshes
            }; */
            // FUNCTIONS FOR FORMATTING CELLS
            const vcolCellEnabled = (params) => {  // so we can use this below
                return params.data.enabledVendorColKeys.includes(params.colDef.field);  // NEW - much shorter
            };
            const vcolCellDisabled = (params) => {
                return !params.data.enabledVendorColKeys.includes(params.colDef.field);
            };
            const vcolCellEmpty = (params) => {
                return !hasValueOrZero(params.value);  // just tells us if this cell is empty... use in other functions / cellClassRules - must check for ZERO!
            };
            const vcolCellComplete = (params) => {  // checks if cell is enabled AND complete
                let isEnabled = vcolCellEnabled(params);  // reuse our previous function
                if (!isEnabled) return false;  // if not enabled (ie: not required) for this cell, return false saying its not incomplete
                return hasValueOrZero(params.value) ? true : false;  // have to check for zero! in case we have zero as entered value in number/price column
            };
            const vcolCellIncomplete = (params) => {  // checks if cell is enabled AND INcomplete
                let isEnabled = vcolCellEnabled(params);  // reuse our previous function
                if (!isEnabled) return false;  // if not enabled (ie: not required) for this cell, return false saying its not incomplete
                return hasValueOrZero(params.value) ? false : true;  // if we DO NOT have a value, then return true - have to check for zero! in case we have zero as entered value in number/price column
            };
            const vcolCellDisabledNobid = (params) => {  // is this disabled because vendor selected No Bid for the line?  
                // Checks for the line, but use this for a cell in cellClassRules, also prevents disabling if col is 'comment' or 'nobid' since those should still be enabled if nobid
                let showFieldsDuringNoBid = ['comment', 'nobid'];  // ALWAYS show these fields, even if No Bid = true
                return params.data.bid.nobid && !showFieldsDuringNoBid.includes(params.colDef.field);  // did vendor select 'No Bid' for this row, and is this field not in showFieldsDuringNoBid?
            };
            const vcolCellEditable = (params) => {  // can this cell be edited?  Is it enabled and not disabled because of nobid?
                // NEW - also must check if this.disableEdit is set, if its already is_submitted
                if (this.disableEdit) {return false}
                return vcolCellEnabled(params) && !vcolCellDisabledNobid(params);
            };
            // Build the cellEditorSelector (chooses which cellEditor to use for each row) -- dynamically build a function that dynamically builds cellEditor!
            const buildCellEditorSelector = (cellEditor, cellEditorParams) => {  // RETURN the function to use as cellEditorSelector... a function that builds a function
                console.log('building cellEditorSelector - cellEditorParams:', cellEditorParams);
                const vcolCellEditorSelector = (params) => {  // used to pass different cellEditor and cellEditorParams for each row/cell -- used to pass no editor for disabled cells
                    // should return object with keys { component, params } which match cellEditor and cellEditorParams
                    let isEnabled = params.data.enabledVendorColKeys.includes(params.colDef.field);  // enabledVendorColKeys is array of plainKey from vendorColsAll - ['price', 'leadtime', ...]
                    if (isEnabled) {
                        return {
                            component: cellEditor,  // cellEditor we passed into outer builder function
                            params: cellEditorParams,  // cellEditorParams we passed into outer builder function
                        };
                    } else {
                        return {
                            component: null,
                        };
                    }
                };
                return vcolCellEditorSelector;
            };
            // Now do the same for cellRenderer -- dynamically build cellRendererSelector 
            const buildCellRendererSelector = (cellRenderer, cellRendererParams) => {  // RETURN the function to use as cellRendererSelector... a function that builds a function
                const vcolCellRendererSelector = (params) => {  // used to pass different cellRenderer and cellRendererParams for each row/cell -- used to pass no Renderer for disabled cells
                    // should return object with keys { component, params } which match cellRenderer and cellRendererParams
                    let isEnabled = params.data.enabledVendorColKeys.includes(params.colDef.field);  // enabledVendorColKeys is array of plainKey from vendorColsAll - ['price', 'leadtime', ...]
                    /* NOT USING THIS - HIDE NoBid lines using CSS instead -- otherwise you have to fully re-render all rows for any drag-handle operations, which is very annoying to do.  CSS updates happen automatically!
                    let isNobid = vcolCellDisabledNobid(params);
                    if (isNobid) {  // do this one first, if No Bid, then show this, not others
                        return {
                            component: 'noBidInputRenderer',
                            params: null,
                        };
                    } */
                    if (isEnabled) {
                        //console.log('this col is enabled, so using this cellRenderer', cellRenderer);
                        return {
                            component: cellRenderer,  // cellRenderer we passed into outer builder function
                            params: cellRendererParams,  // cellRendererParams we passed into outer builder function
                        };
                    } else {
                        return {
                            //component: 'disabledVendorInputRenderer',  // Vue component
                            component: 'simpleDisabledInputRenderer',  // string render function (simpler, faster)
                        };
                    }
                };
                return vcolCellRendererSelector;
            };
            const buildCellClasses = (fieldName, alignment, extraClassesArray) => {  // fieldName and alignment are strings, extraClassesArray is ARRAY of strings
                // CALL THIS when building colDefs -- don't pass the function, pass the RETURN of this function
                // return an ARRAY of classes -- you _could_ return a function like you're doing above for buildCellRendererSelector, but no need right now
                let allCellClasses = ['vendor-input-col'];  // start with this, then add to it
                if (alignment) {
                    allCellClasses.push('column-align-' + alignment);
                } 
                if (fieldName) {
                    allCellClasses.push('vendor-input-col-' + fieldName);  
                }
                if (!!extraClassesArray && Array.isArray(extraClassesArray) && extraClassesArray.length) {  // important to check all these things, in this order
                    // we'll also flatten the array and remove falsey values, to allow for starting with array or undefined, wrapping in array down below
                    allCellClasses = allCellClasses.concat(extraClassesArray.flat().filter(c => !!c));
                }
                return allCellClasses.length ? allCellClasses : null;  // return null if its an empty array
            };  // REMOVING buildHeaderClasses -- redundant with buildCellClasses
            /* const buildHeaderClasses = (fieldName, alignment, extraClassesArray) => {  // fieldName and alignment are strings, extraClassesArray is ARRAY of strings
                // CALL THIS when building colDefs -- don't pass the function, pass the RETURN of this function
                // return an ARRAY of classes -- you _could_ return a function like you're doing above for buildCellRendererSelector, but no need right now
                let allHeaderClasses = [];  // build this up
                if (alignment) {
                    allHeaderClasses.push('column-align-' + alignment);
                } 
                if (fieldName) {
                    allHeaderClasses.push('vendor-input-col-' + fieldName);  
                }
                if (!!extraClassesArray && Array.isArray(extraClassesArray) && extraClassesArray.length) {
                    allHeaderClasses = allHeaderClasses.concat(extraClassesArray);
                }
                return allHeaderClasses.length ? allHeaderClasses : null;  // return null if its an empty array
                //return [...allHeaderClasses, ...extraClassesArray];
            }; */
            if (!this.quoteSheetData) return;  // on initial load, you may not have quoteSheetData yet... must 
            let enabledVendorCols = this.quoteSheetData.getEnabledVendorCols();  // array from vendorColsAll, filtered for ONLY enabled ones on QuoteSheet level (not row level), includes any choices arrays from backend
            enabledVendorCols.forEach(vcol => {
                // IMPORTANT:  Make sure you clone objects/arrays... otherwise all cols will have the same one and you'll have unwanted mutations
                let vcolCellRenderer = vcol.replyGrid.cellRenderer || null;
                let vcolCellRendererParams = cloneDeep(vcol.replyGrid.cellRendererParams) || null;  // SHOULD YOU BE CLONING THESE OBJECTS SO YOU DON'T ACCIDENTALLY MUTATE???
                let vcolCellEditor = vcol.replyGrid.cellEditor || null;  // pass to our buildCellEditorSelector function
                let vcolCellEditorParams = cloneDeep(vcol.replyGrid.cellEditorParams) || null;  // pass to our buildCellEditorSelector function
                let headerLabel = vcol.replyGrid.label || vcol.label;  // used multiple places
                if (vcol.plainKey === 'quoted_price') {
                    headerLabel = headerLabel + ` (${this.quoted_currency})`;
                }
                let vcolCellClassRules = {  // these rules are used for ALL vendorCols
                    'vendor-input-disabled': vcolCellDisabled,
                    'vendor-input-nobid': vcolCellDisabledNobid,  // adds this class if vendor selected "No Bid" for this line -- we use this INSTEAD of changing the cellRenderer -- we just hide everything if noBid!
                    'vendor-input-empty': vcolCellEmpty,  // just tells us if cell is empty... combine with other CSS classes to show gray text, etc.
                };
                if (vcol.replyGrid.showConditionalBackground) {
                    Object.assign(vcolCellClassRules, {  // these rules are only used for cols where you want conditional background colors
                        'vendor-input-enabled': vcolCellEnabled,
                        'vendor-input-complete': vcolCellComplete,
                        'vendor-input-incomplete':  vcolCellIncomplete,
                    });
                }
                console.log('Building colDef for vcol', vcol.plainKey);
                const hiddenPriceFields = ['price', 'subtotal'];  // these are now hidden, because vendor enters their price in 'quoted_price' instead!
                let colDef = {  // YOU SHOULD TAKE ADVANTAGE OF COLUMN TYPES FOR ENCAPSULATING FIELD TYPE LOGIC
                    headerName: headerLabel,
                    headerClass: buildCellClasses(vcol.plainKey, vcol.replyGrid.alignment, [vcol.replyGrid.headerClass]),  // returns array of classes, or null if array is empty
                    type: vcol.replyGrid.type || null,  // col types... very powerful
                    suppressMovable: true,
                    hide: hiddenPriceFields.includes(vcol.plainKey) ? true : false,   // make better???
                    colId: vcol.plainKey,  // just make this explicit since you'll use it a few places
                    field: vcol.plainKey,  // plain names like 'price', 'leadtime' -- without 'enable_' --> make sure your other functions can deal with this
                    headerTooltip: vcol.replyGrid.tooltip || headerLabel,
                    minWidth: vcol.replyGrid.minWidth,
                    maxWidth: vcol.replyGrid.maxWidth,
                    // NO NEED SINCE WE ALREADY FILTERED IN QuoteSheet METHOD:  hide: !this.quoteSheetData.vendorCols[vcol.enableKey],  // get current value of checkbox - enableKey = 'enable_price'...
                    valueGetter: vcol.replyGrid.valueGetter || null,  // if its null, will get value from 'field' (top level of data obj)
                    valueSetter: vcol.replyGrid.valueSetter || null,  // if its null, will get value from 'field' (top level of data obj)
                    valueFormatter: vcol.replyGrid.valueFormatter || null,  // converts from stored value to displayed value
                    valueParser: vcol.replyGrid.valueParser || null,  // converts from input value to stored value
                    valueSetterParser: vcol.replyGrid.valueSetterParser || null,  // optional common parser to use inside valueSetter to handle parsing from all sources (editor, pasting, etc.)
                    genericValueParser: vcol.replyGrid.genericValueParser || null,  // if specified, should be a function that takes a raw value, returns parsed value
                    suppressPaste: vcol.replyGrid.suppressPaste ?? false,  // default to false unless set
                    cellRendererSelector: buildCellRendererSelector(vcolCellRenderer, vcolCellRendererParams),  // dynamically set cellRenderer / cellRendererParams, this removes normal cellRenderer if vendor input is disabled for this col / this row
                    //cellRenderer: vcol.replyGrid.cellRenderer || null,
                    //cellRendererParams: vcol.replyGrid.cellRendererParams || null,  // SHOULD YOU BE CLONING THESE OBJECTS SO YOU DON'T ACCIDENTALLY MUTATE???
                    editable: vcol.replyGrid.editable ?? vcolCellEditable,  // a function that looks at whether its enabled for each line (variant) - modified Aug 5 2022 to allow for setting it in vendor cols js file (so we can always make subtotal not editable)
                    cellEditorSelector: buildCellEditorSelector(vcolCellEditor, vcolCellEditorParams),  // dynamically set cellEditor and cellEditorParams, removed cellEditor if this col not enabled for this row
                    //cellEditor: vcol.replyGrid.cellEditor || null, 
                    //cellEditorParams: vcol.replyGrid.cellEditorParams || null,  
                    singleClickEdit: vcol.replyGrid.singleClickEdit || false,
                    //cellClass: vcol.replyGrid.cellClass || ('vendor-input-col-' + vcol.plainKey),  // maybe combine these?  may not work, since could be function, and can't add string to function
                    cellClass: buildCellClasses(vcol.plainKey, vcol.replyGrid.alignment, [vcol.replyGrid.cellClass]),  // returns array of classes, or null if array is empty
                    cellClassRules: vcolCellClassRules,
                    //refData: vcol.replyGrid.refData || null,  // refData used by cellFormatter/cellEditor -- used for SOME choice fields, should be a single object of {value: label, value: label, ...}
                    validChoices: (vcol.choices && Array.isArray(vcol.choices)) ? [...vcol.choices] : null,  // array of choices that are valid values (make a copy) or null -- use especially for select/choice fields
                    // ag-grid docs don't say anything about being able to add custom keys to colDefs like this, but it seems to work
                    // alternative -- put all field info / choices info in grid context -- then its available everywhere.
                    // less-good alternative -- put a copy of valid choices in each grid row -- in variant or bid?  or a method to get them?
                };
                responseColDefs.push(colDef);
            });
            return sortBy(responseColDefs, ['sort_order']);  // sort them by sort_order before returning
        },
        buildColDefs: function() { // build and return colDefs -- don't set them here -- return to caller so caller can do it
            // figure out which 'internal' cols are on/off from this.quoteSheetData.internalCols.show_....
            // calculate the vertical padding you want, enforced on the first column and 'validation' column since those will always be there, they use special cell renderers
            let rowCount = this.rowData.length;
            let verticalPadding = rowCount < 20 ? (rowCount < 8 ? '25px' : '15px') : '10px';
            let newColDefs = [
                {   // NEED THIS - this is how row grouping is actually done -- by groupId, which is the ID of the ITEM for each line
                    // hide: true // rowGroup: true  -- don't need to show it, but need it for grouping since we have all info on each line, and we have hide open parents
                    // this way you can have one PRODUCT on here multiple times, but variants are grouped separately because grouping is by QuoteSheetItem ID (QsItemForReply), not product ID
                    headerName: 'Group Manual',
                    field: 'groupId',
                    hide: true,
                    rowGroup: true,
                    headerClass: 'pl-3',
                    cellRenderer:'agGroupCellRenderer',
                    cellRendererParams: {
                        suppressCount: true,
                        checkbox: false,
                    },
                },
                /* {
                    headerName: '',  // just for showing row grouping indicators
                    //cellClass: 'viz-col',
                    pinned: true,
                    minWidth: 25,
                    maxWidth: 25,
                }, */
                {
                    headerName: 'Item Details',
                    marryChildren: true,
                    children: [
                        {
                            headerName: 'Item Name',
                            field: 'itemName',
                            hide: this.quoteSheetData.internalCols.show_name === false,
                            pinned: true,
                            type: ['noEditCol', 'firstChildVisible'],
                            minWidth: 100,
                            maxWidth: 250,
                            cellStyle: {
                                'font-weight': 'bold',
                            },
                            headerClass: ['pl-3'],
                            cellClass: ['viz-col', 'pl-3', 'noedit-cell'],
                            cellRenderer: 'dynamicPaddingRenderer',
                            cellRendererParams: {
                                padding: verticalPadding,
                            },
                            valueGetter: (params) => {return params.data ? params.data.itemName : ''},
                        },
                        {
                            headerName: 'Part Number',
                            field: 'partNumber', 
                            hide: this.quoteSheetData.internalCols.show_part_number === false,
                            pinned: true,
                            type: ['noEditCol', 'firstChildVisible'],
                            cellClass: ['noedit-cell'],
                            minWidth: 100,
                            maxWidth: 250,
                            valueGetter: (params) => {return params.data ? params.data.partNumber : ''},
                        },
                        {
                            headerName: 'Item Description',
                            field: 'itemDescription', 
                            hide: this.quoteSheetData.internalCols.show_description === false,
                            pinned: true,
                            type: ['noEditCol', 'firstChildVisible'],
                            cellClass: ['noedit-cell'],
                            minWidth: 100,
                            maxWidth: 250,
                            valueGetter: (params) => {return params.data ? params.data.item.description : ''},
                        },
                        {
                            headerName: 'Variant Description',
                            field: 'variantDescription',
                            pinned: true,
                            type: ['noEditCol'],
                            cellClass: ['noedit-cell'],
                            hide: !this.hasMultipleVariants,
                            minWidth: 100,
                            maxWidth: 250,
                            valueGetter: (params) => {return params.data ? params.data.variant.description : ''},
                        },
                        {
                            headerName: 'Need by Date',
                            field: 'needByDate', 
                            hide: this.quoteSheetData.internalCols.show_need_by_date === false,
                            pinned: true,
                            type: ['noEditCol'],
                            cellClass: ['noedit-cell'],
                            minWidth: 100,
                            maxWidth: 250,
                            valueGetter: (params) => {return params.data ? params.data.variant.need_by_date : ''},
                            valueFormatter: agDateFormatter,
                        },
                    ],
                },
                {
                    headerName: 'Quantity',
                    marryChildren: true,
                    children: [
                        {
                            headerName: 'Quantity',
                            field: 'quantity', 
                            hide: this.quoteSheetData.internalCols.show_quantity === false,
                            pinned: true,
                            type: ['quantityCol', 'noEditCol'],
                            headerClass: ['column-align-right'],
                            cellClass: ['noedit-cell', 'column-align-right'],
                            minWidth: 80,
                            maxWidth: 120,
                            valueFormatter: agNumberFormatter,
                        },
                        {
                            headerName: 'UoM',
                            field: 'uom',
                            hide: this.quoteSheetData.internalCols.show_uom === false,
                            pinned: true,
                            type: ['quantityCol', 'noEditCol'],
                            cellClass: ['noedit-cell'],
                            minWidth: 80,
                            maxWidth: 120,
                        },
                        {
                            headerName: 'Timeframe',
                            field: 'quantity_timeframe',
                            hide: this.quoteSheetData.internalCols.show_timeframe === false,
                            pinned: true,
                            type: ['quantityCol', 'noEditCol'],
                            cellClass: ['noedit-cell'],
                            minWidth: 100,
                            maxWidth: 140,
                        },
                    ],
                },
                {
                    headerName: 'Your Response',
                    headerClass: 'vendor-input-header',
                    headerGroupComponent: 'vendorResponseHeaderRenderer',
                    headerGroupComponentParams: {
                        subheading: 'Please fill in these columns.',
                    },
                    marryChildren: true,
                    children: this.buildResponseColDefs().concat(
                        {
                            headerName: '',
                            field: 'bidValid',
                            editable: false,
                            minWidth: 50,
                            maxWidth: 60,
                            headerClass: ['vendor-input-col'],
                            cellClass: 'col-bidvalid',
                            valueGetter: (params) => {
                                return params.data ? params.data.isValid() : null;
                            },
                            cellRenderer: 'validationStatusRenderer',
                            cellRendererParams: {
                                padding: verticalPadding,
                            },
                        }
                    ),
                },
            ];
            return newColDefs;
        },
        // API METHODS
        // ---------------------------------
        showLoadingMessage: function(msg) {
            // overwrite entire loadingOverlayComponentParams object, doing in function will make it react right away (vs. computed prop)
            this.loadingOverlayComponentParams = {loadingMessage: msg}; 
            this.$nextTick(() => this.gridApi.showLoadingOverlay());
        },
        // GETTING DATA
        setDataFromApi: function(respData) {
            // set local data from API data
            this.disableEdit = respData.is_submitted === true ? true : false;  // explicitly check if true
            this.quoteSheetData = new QuoteSheet(respData.quotesheet);  // NOTE: response.data for QuoteSheetReply has quotesheet one level deeper
            this.quoted_currency = respData.quoted_currency;  // might be empty string if needs to be selected
            this.exchangeRateData = respData.exchange_rate_data ?? {};  // might not have it if not set quoted_currency yet
            this.updateGridContext();  // sets the currency, etc
            // BUILD and SET ROW DATA
            this.rowData = this.buildGridLines(respData); // maybe set differently?
            // update rowData using api.setRowData() OR
            //let newRowData = this.buildGridLines(respData);
            //this.gridApi.setRowData(newRowData);
            // update rowData using vue binding - PICK ONE
            // UPDATE COL DEFS - after setting quoteSheetData and any context -- and after setting row data too?  To make sure we process through all rows and API data to look for any variants, any process all stuff from API?
            this.updateColDefs(); // wait until nextTick?  or some callback from grid
            this.canShowGrid = true;
            // RESET ROW HEIGHTS AND COL WIDTHS - update counts
            // NOT DOING THESE HERE - GRID MAY NOT BE READY YET, CALL THEM IN ON GRID READY
            //this.gridApi.expandAll();  // just to be sure
            //this.gridApi.sizeColumnsToFit();  // this will then trigger update row heights via @event callback
            console.log('hello from end of setDataFromApi');
            this.isDirty = false;  // reset isDirty flag
        },
        buildGridLines: function(respData) {
            // build & return flat array of line items for the grid - don't set anything in here -- return array to caller
            let existingBidByVariantId = keyBy(respData.bids, 'qs_item_variant_id');  // makes one big object with keys being bid.qs_item_variant_id and value being bid object
            let flatRowData = [];  // we'll build this up then return it
            let nestedItems = respData.quotesheet.quotesheet_items;
            const quoteSheetCurrency = respData.quotesheet.currency;  // 3-letter currency code
            const quotedCurrency = respData.quoted_currency;  // 3-letter currency code for quoted_price on ReplyBid / quoted_currency on the Reply
            const newBidData = {  // data object that we'll pass to QuoteSheetReplyBid(newBidData) if there is no existing bid -- the defaults for currency, etc.
                // don't set id -- that gets a default value in your QuoteSheetReplyBid constructor
                price_currency: quoteSheetCurrency,
                quoted_price_currency: quotedCurrency,  // the currency part of 'quoted_price' MoneyField
            };
            nestedItems.forEach(item => { // item will be object from API, will have keys 'variants', 'linked_product', and other top-level item fields
                // check if there are more than one variant... if there are FOR ANY ITEM, set this.hasMultipleVariants = true
                if (item.variants.length > 1) { this.hasMultipleVariants = true; }
                item.variants.forEach(variant => {  // loop through all variants... we are not building tree data, but will use row grouping instead
                    // look for existing bid for this variant -- using our keyed map / variant.id
                    let bidData = existingBidByVariantId[variant.id] || newBidData;  // set defaults for new bid lines in newBidData to instantiate QuoteSheetReplyBid
                    // NEW - Sept 28 2022 - if a bid was saved with empty price (None) then we likely got 'USD' as default currency here, no matter what (since backend MoneyField requires(ed) a default currency)
                    // so in here, we will make sure currency is set to quotesheet currency if price is empty/null/undefined
                    // if price (amount) is NOT empty and we have a currency mismatch, we'll log error
                    if (bidData.price_currency && bidData.price_currency !== quoteSheetCurrency) {
                        if (hasValueOrZero(bidData.price)) {
                            // if we have a value for price but have currency mismatch, log error
                            console.error(`Currency mismatch in QuoteSheetReply ID ${this.replyId} - Bid ID ${bidData.id}`)
                        } else {
                            // otherwise, change the currency code - backend default did not match quotesheet currency (can happen due to funky required default currency in MoneyField)
                            console.log(`Changing currency for empty bid price on bid ID ${bidData.id} - from ${bidData.price_currency} to ${quoteSheetCurrency}`);
                            bidData.price_currency = quoteSheetCurrency;
                        }
                    }
                    // NEW - June 1 2023 - added 'quoted_price' that uses supplier-selected currency 
                    if (bidData.quoted_price_currency && bidData.quoted_price_currency !== quotedCurrency) {
                        if (hasValueOrZero(bidData.quoted_price)) {
                            // if we have a value for price but have currency mismatch, log error
                            console.error(`Currency mismatch on quoted_price in QuoteSheetReply ID ${this.replyId} - Bid ID ${bidData.id}`)
                        } else {
                            // otherwise, change the currency code
                            console.log(`Changing currency for empty bid price on bid ID ${bidData.id} - from ${bidData.quoted_price_currency} to ${quotedCurrency}`);
                            bidData.quoted_price_currency = quotedCurrency;
                        }
                    } else if (!bidData.quoted_price_currency) {
                        // if quoted_price_currency is NOT SET, we should set it to the quoted_currency
                        bidData.quoted_price_currency = quotedCurrency;
                    }
                    // now go look for existing bid
                    flatRowData.push(new BidGridRow({
                        bid: new QuoteSheetReplyBid(bidData),  // make sure to pass in instance of QuoteSheetReplyBid - QuoteSheetReplyBid({})
                        item: new QsItemForReply(item),
                        variant: new QsItemVariantForReply(variant),
                        exchangeRate: this.exchangeRate,
                    }));
                });
            });
            return flatRowData;  // no need to reverse anymore apparently...
            //return flatRowData.reverse();  // return the new flat array to caller (and reverse it because I don't know why ag-grid always needs it...)
        },
        getData: function() {
            // get the data from API service
            this.loading = true;
            //this.showLoadingMessage('Loading...');
            // TODO - update with new endpoint for reply
            //let dummyQuoteSheetId = 'aCpxmZT8renUV2ND9Sd0YJ';
            return suppliosApi.quoteSheetReply.retrieve(this.replyId)
                .then(response => {
                    //console.log('getData - response.data');
                    //console.log(response.data);
                    //console.log(JSON.stringify(response.data));
                    this.setDataFromApi(response.data);
                    return true;
                })
                .catch(error => {
                    this.apiErrorHandler(error, 'There was an error getting the Quote Sheet data.  Please contact Support.');
                    return false;
                })
                .then(success => {
                    this.loading = false;
                    //this.gridApi.hideOverlay();
                    console.log('from getData final then - just called api.hideOverlay');
                    return success;
                });
        },

        // SAVING DATA & CLOSING METHODS
        onCloseClick: function() {
            // look at unsaved data, if none, then emit close event
            // checkUnsavedData() returns a PROMISE resolves to true, false --> true = continue.  false = abort
            this.checkUnsavedData().then(continueOk => {
                if (continueOk) {
                    this.emitClose();
                } else {
                    // if NOT ok to continue, nothing really to do...
                    console.log('Aborted the close'); 
                }
            });
        },
        checkUnsavedData: function() {
            // will show confirmation modal to save/discard unsaved data if there is any
            // RETURN PROMISE that resolves to Boolean:
            //  - resolve to true = OK to proceed -- either no unsaved changes, or no desire to save unsaved changes
            //  - resolve to false = not OK to proceed, user wants to cancel and save changes or make more changes
            if (!this.isDirty) {
                return Promise.resolve(true);  // if not dirty, then no unsaved changes, OK to proceed, return promise resolve true
            } else {  // handle unsaved changes
                return this.$bvModal.msgBoxConfirm('Your unsaved changes will be lost if you close without saving.  Are you sure you want to close?', {
                    title: 'Unsaved Changes',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Yes, Discard Changes',
                    cancelTitle: 'No, Cancel',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                    })
                    .then(value => {  // value will be boolean --> OK button = true.  Cancel button = false.  Other close methods = undefined.
                        if (value) {  // if user clicked on OK (discard changes)
                            return true;  // return true to say 'ok to continue'
                        } else {  // if they clicked on cancel, or closed the modal some other way
                            return false;  // return false, to say 'do not continue'
                        }
                    })
                    .catch(err => { // probably no chance of getting here... but just return false if you do
                        console.warning(err);
                        return false;
                    });
            }
            // make sure your promise chain for confirm box returned something from this method!
        },
        emitClose: function() {
            this.$emit('close-me');
            console.log('CLOSE ME');
        },
        dumpApiData: function() {
            let isSubmit = false;
            let toConsole = true;
            this.saveToBackend(isSubmit, toConsole);
        },
        saveDraft: function() {
            let isSubmit = false;
            let toConsole = false;
            this.saveToBackend(isSubmit, toConsole);
            /* let saveOk = this.saveToBackend(isSubmit, toConsole);  // returns a Promise resolving to Boolean
            saveOK.then((saveSuccess) => {

            }) */
        },
        saveSubmit: function() {
            let isSubmit = true;
            let toConsole = false;
            this.saveToBackend(isSubmit, toConsole);
        },
        saveToBackend: function(isSubmit, toConsole, stayOpen) {  
            // isSubmit: Boolean - if TRUE, we should mark form as SUBMITTED, if FALSE, don't mark as submitted, only draft
            // toConsole:  don't call API, just dump data to console
            // stayOpen: Boolean, if TRUE, we'll set the returned data back in the grid, keep this open.  if FALSE, we'll show success message and close
            // grab current display position?  this.gridApi.getLastDisplayedRow();
            // do any cleaning or row prep?
            // if isSubmit = true -- show some confirmation modal saying 'are you sure?'
            this.saving = true;  // moved this up to disable the save button ASAP - must set to false before any return
            this.gridApi.stopEditing();  // make sure we are done editing so any final changes are saved
            let currentLastDisplayedIndex = this.gridApi.getLastDisplayedRow();  // so we can use ensureIndexVisible(index, position) after the save to go to same spot
            let currentRowData = this.getRealRowData();  // returns only rows with real data, not placeholder group rows
            if (isSubmit) {  // for now, only do validation if isSubmit = true
                let allRowsValid = this.allRowsValid(currentRowData);
                if (!allRowsValid) {
                    this.$toast.warning('Please complete all required lines');
                    this.saving = false;
                    return Promise.resolve(false);
                }
            }
            this.showLoadingMessage('Saving Your Response...');
            let apiData = this.prepareDataForApi(currentRowData); // make sure your validation method didn't change it... otherwise have this function get its own fresh data ?
            apiData['is_submit'] = isSubmit;  // extra field on serializer to set saving as SUBMITTED or not submitted, draft - NOTE/UPDATE:  we may override this on backend... if all ToDo Reply (DocRequestReply, QuoteSheetReply) should be submitted together, we will only mark it as submitted when ALL of them are submitted together
            if (toConsole) {  // just dump to console
                console.log('dumping data for API');
                console.log(apiData);
                this.saving = false;
                return Promise.resolve(true);
            } else {  // save to backend
                return suppliosApi.quoteSheetReply.vendorUpdate(this.replyId, apiData)
                    .then(response => {
                        console.log('save successful - response data:');
                        console.log(response.data);
                        // handle flow differently if we're supposed to stay open (reload data in grid) or close and finish
                        if (stayOpen) {
                            let successMsg = isSubmit ? 'Your reply was successfully submitted' : 'Draft reply saved';
                            this.$toast.success(successMsg);
                            this.setDataFromApi(response.data);  // this resets the isDirty flag too -- only do this if you're NOT closing it
                        } else {
                            this.successModalShowing = true;
                            setTimeout(() => {  // may have to wrap this in a promise... it works, but that is probably the right way... otherwise things don't stop here... but delay to call emitClose still happens
                                this.emitClose();
                            }, 2500);
                            // below line works, but will close successmessage at same time as emitting close, which may look funny
                            // this.showSuccessModal(2500).then(() => this.emitClose());
                            // showSuccessModal returns a promise, has a delay to show successmodal
                        }
                        // IF CLOSING - show success message  - successModalShowing = true
                        return true;
                    })
                    .catch(error => {
                        this.apiErrorHandler(error, 'Error while saving your reply.  Please contact Support.');
                        this.saving = false;  // make sure we don't get stuck in saving state
                        return false;
                    })
                    .then(success => {
                        console.log(`Scrolling to index: ${currentLastDisplayedIndex}`);
                        this.gridApi.ensureIndexVisible(currentLastDisplayedIndex, 'bottom');  // scroll to the same position we had before save
                        this.saving = false;
                        this.gridApi.hideOverlay();
                        return success;
                    });
            }
        },
        showSuccessModal: function(time) {  // shows successModal for XXXX ms, then RETURNS A PROMISE that resolves to TRUE
            let delayTime = time || 2500;  // default time if not passed
            this.successModalShowing = true;
            return new Promise((resolve) => {
                setTimeout(() => {
                    this.successModalShowing = false;
                    resolve(true);  
                }, delayTime);
            });
        },
        allRowsValid: function(rowData) {
            let { invalid } = countBy(rowData, 'isValidStatus');  // isValidStatus is getter than calls isValid() on BidGridRow -- so add any new validation logic there
            console.log(`From allRowsValid - ${invalid} rows`);
            // invalid count will be undefined if there were no invalid rows
            return !invalid;  // invalid is a count of invalid rows (also have 'valid' key if needed) - if no invalid rows then invalid will be undefined, then we're good
        },
        getRealRowData: function() { // this returns array of rowNode.data objects (instances of BidGridRow)
            // ONLY for rows/nodes that have real data... not the 'fake' group rows
            let allRowData = [];
            this.gridApi.forEachNode((node) => {
                allRowData.push(node.data);
            });
            return allRowData.filter(data => !!data);  // filter out any rows that don't have data object (those are the rowGroup rows)
        },
        prepareDataForApi: function(rowData) {  // put everything in format to send to backend -- rows + any other QuoteSheetReply metadata
            let bidLines = rowData.map(bidRow => bidRow.formatForApi(this.replyId));
            let quoteSheetReplyObj = {  // the object you'll send to API
                id: this.replyId,  // ID of THIS QuoteSheetReply
                quotesheet_id: this.quoteSheetData.id,  // ID of the QuoteSheet, from this.quoteSheetData - write-serializer expects quotesheet_id
                comment: this.quoteSheetReplyData.comment,
                updated_bids: bidLines,  // write serializer expects 'updated_bids' -- 'bids' is only for READS
            };
            return quoteSheetReplyObj;
        }
    }
}
</script>

<style lang="scss">

@import "../../css/spl-variables.scss";
@import "~ag-grid-community/src/styles/ag-grid.scss";
@import "~ag-grid-community/src/styles/ag-theme-alpine/sass/ag-theme-alpine-mixin";
//@import "../../css/supplios-ag-grid.scss";  // has @mixin ag-supplios-generic-mixin {

@mixin item-group-indicator {   // use @include item-group-indicator;
    content: '';
    position: absolute;
    display: block;
    height: 120%;  // override in each?  make it larger so it always overflows
    width: 3px;
    top: 0;  // override in each for sure
    left: 0;
    background-color: var(--primary-500);
    // background: linear-gradient(to left, var(--gray-100), var(--primary-500)); // works and looks OK, but maybe hard on rendering
    border-top-left-radius: 0;
    border-top-right-radius: 5px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 5px;
}

.ag-theme-alpine-custom {
    @include ag-theme-alpine((
        // PUT THEME PARAMETERS HERE
        //alpine-active-color: deeppink
        background-color: $gray-200,
        //background-color: #fff,
        odd-row-background-color: null,
        header-background-color: $gray-200,
        row-border-color: $gray-200,  // I made it match background-color so empty variant cells look normal.   normal value:  ag-derived(secondary-border-color),
        grid-size: 5px,  // normal for alpine seems to be 6px.  its not bad, but should shrink horizontal padding
        // Horizontal padding for grid and header cells (vertical padding is not set explicitly, but inferred from row-height / header-height
        cell-horizontal-padding: ag-derived(grid-size, $times: 2),  // originally was grid-size, $times: 3
 
        // Fonts
        font-family: ("Helvetica Neue", sans-serif),
        font-size: 12px,
    ));

    // INPUTS
    input[class^=ag-] {
        background-color: #fff;
    }

    // HEADER AREAS
    /* .ag-header-viewport {
        background-color: var(--primary-50);
    } */
    
    // STATUS BAR 
    .ag-status-bar {
        background-color: #fff;
    }

    // GROUP HEADERS
    .ag-header-group-cell {
        &.vendor-input-header {
            border-top: 4px solid var(--primary);
        }
        .ag-header-group-cell-label {
            
            .ag-header-group-text {  // will apply to all column groups
                font-size: 140%;
            }
            &.vendor-response-area-header {  // just for vendor response area
                .ag-header-group-text {  // heading and subheading are inside this
                    .vendor-response-area-heading {
                        color: var(--primary-700);
                    }
                    .vendor-response-area-subheading {
                        font-size: 70%;  // reset this to something more reasonable
                        color: var(--gray-600);
                        margin-top: 3px;
                    }
                }
            }
        }
    }

    // blue background on vendor input area headers
    .ag-header-group-cell.vendor-input-header,
    .ag-header-cell.vendor-input-col {
        background-color: var(--primary-50);
    }

    // HEADER CELLS
    .ag-header-row {
        .ag-header-cell {  // .ag-header-cell is the top-level div of a header cell
            &.column-align-left .ag-cell-label-container .ag-header-cell-label {justify-content: flex-start; text-align: left;}  // .ag-header-cell-label is display: flex, has .ag-header-cell-text inside it (span) - need to add text-align on it so text in the span aligns correctly, especially if it wraps
            &.column-align-center .ag-cell-label-container .ag-header-cell-label {justify-content: center; text-align: center;}
            &.column-align-right .ag-cell-label-container .ag-header-cell-label {justify-content: flex-end; text-align: right;}
            .ag-header-cell-label {
                .ag-header-cell-text {
                    white-space: normal;
                    // text-align: center;  // use flex stuff above instead?  not both
                }
            }
        }
    }

    // ITEM/VARIANT GROUPING STYLES
    .ag-pinned-left-cols-container {
        .ag-row {
            &.item-firstrow {  // FIRST VARIANT
                &::after {
                    @include item-group-indicator;
                    top: 3px;  // shift DOWN
                    border-bottom-left-radius: 0;
                    border-bottom-right-radius: 0;
                }
            }
            &.item-midrow {  // MIDDLE VARIANT
                &::after {
                    @include item-group-indicator;
                    border-radius: 0;
                }
            }
            &.item-lastrow {  // LAST VARIANT
                &::after {
                    @include item-group-indicator;
                    top: auto;  // shift UP
                    bottom: 3px;
                    border-top-left-radius: 0;
                    border-top-right-radius: 0;
                }
            }
            &.item-firstrow.item-lastrow {  // ONLY VARIANT
                &::after {
                    @include item-group-indicator;
                    top: 3px;
                    height: calc(100% - 6px);
                }
            }
        }
    }
    .ag-row.group-multiple-variants {
        .ag-cell[col-id=variantDescription] {
            &::after {
                @include item-group-indicator;
                background-color: var(--primary-300);  // slightly different color for variant indicators
                top: 3px;
                height: calc(100% - 6px);
            }
        }
    }
        
    // ROWS
    .ag-row {

        &.item-lastrow {  // LAST VARIANT
            border-bottom-color: var(--gray-600);  // darker border for better visual of groups
        }
    
        /*
        &.item-firstrow {  // FIRST VARIANT
            .ag-cell.viz-col {  // cells have position: absolute by default...
                border: none;
                &::after {
                    @include item-group-indicator;
                    top: 3px;  // shift DOWN
                    border-bottom-left-radius: 0;
                    border-bottom-right-radius: 0;
                }
            }
        }
        &.item-midrow {  // MIDDLE VARIANT
            .ag-cell.viz-col {  // cells already have position: absolute 
                border: none;
                &::after {
                    @include item-group-indicator;
                    border-radius: 0;
                }
            }
        }
        &.item-lastrow {  // LAST VARIANT
            border-bottom-color: var(--gray-600);  // darker border for better visual of groups
            .ag-cell.viz-col {  // cells already have position: absolute 
                border: none;
                &::after {
                    @include item-group-indicator;
                    top: auto;  // shift UP
                    bottom: 3px;
                    border-top-left-radius: 0;
                    border-top-right-radius: 0;
                }
            }
        }
        &.item-firstrow.item-lastrow {  // ONLY VARIANT
            .ag-cell.viz-col {  // cells already have position: absolute 
                border: none;
                &::after {
                    @include item-group-indicator;
                    top: 3px;
                    height: calc(100% - 6px);
                }
            }
        }*/

        // CELLS (nested in .ag-row)
        .ag-cell {
            
            // must specify things in increasing specificity... remember that later stuff overrides earlier stuff
            background-color: #fff;  // if doing this, then set overall theme background-color to something else
            // GENERAL CELL THINGS
            &:not(.ag-cell-inline-editing) {  // this applies to all cells when NOT inline editing... watch for problems, especially with things like drag handle, etc.
                display: flex;  // trying this out.... to better center text vertically... but may not be great.  normal is display: block
                align-items: center;
                // now try to set the first element within the cell with width: 100% so you can more easily do center/right align
                > *:not(.ag-fill-handle) {  // watch for problems with this...  .ag-fill-handle should have position: absolute, but might depend on other stuff around it
                    width: 100%;
                }
            }

            &.ag-cell-wrap-text {
                word-break: break-word; // normally it is break-all
                line-height: normal;
            }

            // you can override these for individual columns - using both text-align and justify-content because some cells may have flex, maybe not
            &.column-align-left {
                text-align: left;
                justify-content: flex-start;
            }
            &.column-align-center {
                text-align: center;
                justify-content: center;
            }
            &.column-align-right {
                text-align: right;
                justify-content: flex-end;
            }
            .cell-muted {
                background-color: $gray-100;
            }

            //padding-left: 10px;  // normal x-padding for ag-theme-alpine is 17px.  11px for balham
            //padding-right: 10px;  
            //&.less-padding-left { padding-left: 5px;}
            //&.less-padding-right { padding-right: 5px;}

            // INDIVIDUAL COLUMNS -- can mix and match with other classes to do advanced things
            // put these before your conditional formatting rules
            /* &.viz-col {
                background-color: var(--gray-200);
            } */
            &.vendor-input-col-price {
                text-align: right;
                &.vendor-input-empty {text-align: left;}
                &.vendor-input-disabled {text-align: center;}  // to match the others
            }
            &.vendor-input-col-moq {
                text-align: right;
            }
            &.vendor-input-col-comment,
            &.vendor-input-col-nobid {
                background-color: #fff;
            }
            &.col-bidvalid {
                text-align: center;
                background-color: #fff;
            }

            // CONDITIONAL FORMATTING
            &.noedit-cell {  // .noedit-cell is for item data -- cols not supposed to be filled-in by vendors - item details stuff
                background-color: var(--gray-100);
            }
            &.vendor-input-disabled {  // for cells in cols that are inputs, but this cell (row) is disabled for this col
                background-color: var(--gray-200);
                color: var(--gray-400); // even more muted
                text-align: center;
                span {
                    width: 100%;
                }
            }
            //&.vendor-input-enabled {}
            &.vendor-input-complete {  // this gets added only when cells are enabled AND not blank
                background-color: var(--success-50);
            }
            &.vendor-input-empty {
                &:not(.ag-cell-inline-editing) {
                    color: var(--gray-400);  // show highly muted text for placeholders
                }
            }
            &.vendor-input-incomplete {  // this gets added only when cells are enabled AND blank
                background-color: var(--warning-50);  // don't set background on :not(.ag-cell-inline-editing) 
                /* &:not(.ag-cell-inline-editing) {
                    //color: var(--gray-400);  // easier to do it here compared to every cell renderer
                } */
            }
            &.vendor-input-nobid {
                // if vendor clicked on 'No Bid' for this line, this gets added to all cells in that line
                background-color: var(--gray-200);
                > * {
                    display: none;
                }
                &::after {
                    content: 'No Bid';
                    position: absolute;
                    //height: 100%;
                    //width: 100%;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    display: block;
                    //text-align: center;
                }
            }
        }

        &.ag-row-hover {
            //background-color: var(--primary-50);
            background-color: ag-param(row-hover-color);  // this gets whatever color you have set for hover in theme params
            .ag-cell,  // doing this for normal cells, and noedit-cell
            .ag-cell.noedit-cell,
            .ag-cell.vendor-input-disabled,
            .ag-cell.vendor-input-enabled,
            .ag-cell.vendor-input-incomplete {
                //background-color: var(--primary-50);
                background-color: ag-param(row-hover-color);
            }
        }
    }

    // OTHER STUFF YOU USE IN THE GRID
    .datepicker-cell-wrapper {
        .vc-container {
            border: none;  // ag editor already puts on a border, so get rid of this one
        }
    }
}

</style>